import * as webCryptoSecurity from '@portal/security';

/**
 * Compatibility layer for the legacy adapter API.
 * The new shared webcrypto library exposes the same functionality as a module,
 * so we resolve it directly instead of relying on a legacy global script.
 */
export const getWebCryptoSecurity = () => {
  if (!webCryptoSecurity) {
    throw new Error('webcrypto.init.not.available');
  }
  return webCryptoSecurity;
};
